import { useState } from "react";
import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import FiltersMappingCodes from "./filtersMappingCodes/filtersMappingCodes";
import { IntegrationCodeResponse } from "@/main/models/response";
import { IntegrationCodeRequest } from "@/main/models/request";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { withQueryparams } from "@/main/components/core/queryParams/queryparams";
import GridMappingCodes from "./gridMappingCodes/gridMappingCodes";

function MappingCodesScreen() {
	const [dataGrid, setDataGrid] = useState<IntegrationCodeResponse[]>([]);
	const [formFilters, setFormFilters] = useState<IntegrationCodeRequest | null>(null);

	function onResetSearch() {
		if (isNullUndefined(formFilters)) return;

		setDataGrid([]);
		setFormFilters(null);
	}

	async function getDataIntegrationMappingCodes(
		filters: IntegrationCodeRequest | Partial<IntegrationCodeRequest> = {},
		isResetSearch: boolean = true,
	) {
		const request: IntegrationCodeRequest = {
			...(isResetSearch ? {} : formFilters),
			...(filters as IntegrationCodeRequest),
			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize30,
		};

		onResetSearch();
		setFormFilters(request);
	}

	const titlePage = `${getTranslateByKey("module.integration")} > ${getTranslateByKey("screen.mappingCodes")}`;
	return (
		<ContainerScreen title={titlePage}>
			<FiltersMappingCodes
				formFilters={formFilters}
				getDataIntegrationMappingCodes={getDataIntegrationMappingCodes}
				onResetSearch={onResetSearch}
			/>
			<GridMappingCodes dataGrid={dataGrid} formFilters={formFilters} setDataGrid={setDataGrid} />
		</ContainerScreen>
	);
}

export default withQueryparams(MappingCodesScreen);
